/*******************************************************************
* PAGE        : CommonModal
* REMARKS     : Comman Modal Component
* CREATED ON  : 03-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 24-02-2026
********************************************************************/

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import ButtonComponent from "../ButtonComponent/ButtonComponent";
import { Images } from "../../utils/Images";

function CommonModal(props) {
    const { Open = true, Title, StaticTitle, ActionText, onClose, maxWidth, IsLoading, onSave, onCancel, IsScroll, children, IsDeletePopup, OrderNO, IsDeleteMassage, SaveButtonName, CancelButtonName, disableOuterClick, isHeaderVisible } = props;
    const handleClose = () => {
        onClose(false)
    };

    // let lastWord = Title.substring(Title.lastIndexOf(" ") + 1);
    // 'xs'    | 'sm'    | 'md'    | 'lg'    | 'xl'
    // md = 900px lg = 1200px  xl = 1536px
    return (
        <Dialog open={Open}
            fullWidth={true}

            maxWidth={maxWidth}
            onClose={(event, reason) => {
                if (disableOuterClick && reason === 'backdropClick') return;
                handleClose();
            }}
            // onClose={props.isOuterClick == undefined ? handleClose : props.isOuterClick}
            scroll={IsScroll != undefined ? 'body' : 'paper'}
            aria-labelledby="scroll-dialog-title"
            style={{ borderRadius: "24px" }}
        >
            {/* style={maxWidth == 'md' ? { width: '900px' } : maxWidth == 'lg' ? { width: '1200px' } : maxWidth == ' xl' && { width: '1536px' }} */}
            {/* style={!IsDeletePopup ? { minHeight: 'calc(75vh - 70px)' } : {}} */}
            <div className="modal-content-layout">
                {!isHeaderVisible
                    && <div style={{ display: 'flex', justifyContent: 'space-between', height: "56px", borderBottom: "0.5px dashed #206BB1", marginBottom: "8px" }}>
                        <DialogTitle style={{ lineHeight: "100%" }} id="scroll-dialog-title">{StaticTitle ? StaticTitle || Title : StaticTitle || Title}</DialogTitle>
                        {OrderNO != "" && OrderNO != undefined && OrderNO != null && <DialogTitle style={{ marginBottom: '0px' }} >{OrderNO}</DialogTitle>}
                        <img src={Images.modalclose} onClick={onClose} style={{ cursor: "pointer", height: "24px", width: "24px", position: "absolute", top: "16px", right: "24px" }} />
                    </div>}
                <DialogContent style={{ overflow: 'hidden', }} >
                    <DialogContentText>
                        {IsDeletePopup && <Typography color='textPrimary' style={{ fontSize: 20, fontWeight: 'bold' }}>{IsDeleteMassage ? IsDeleteMassage : `Are you sure you want to ${Title}?`}</Typography>}
                    </DialogContentText>
                    {children}
                </DialogContent>
                {IsDeletePopup &&
                    <DialogActions>
                        <ButtonComponent autoFocus size="small" color="primary" disabled={IsLoading ? true : false} onClick={onSave}>{SaveButtonName ? SaveButtonName : ActionText}</ButtonComponent>
                        <ButtonComponent size="small" color="tertiary" disabled={IsLoading ? true : false} onClick={onCancel ? onCancel : handleClose}>{CancelButtonName ? CancelButtonName : "Cancel"}</ButtonComponent>
                    </DialogActions>}
            </div>
        </Dialog>
    );
}

export default CommonModal;
